class OwnNewRateComponent {
    constructor(ownNewRateComponent) {
        if (!(ownNewRateComponent instanceof HTMLElement)) {
            throw new TypeError('The element must be an HTML element.');
        }
        
        this.ownNewRateComponent = ownNewRateComponent;

        // assign DOM elements to properties
        this.btn = this.ownNewRateComponent.querySelector('.own-new-rate-button');
        this.targetId = this.btn.getAttribute('aria-controls');
        this.target = document.getElementById(this.targetId);
        this.btnDisabled = this.btn.getAttribute('aria-disabled');

        // store the bound function reference
        this.boundTogglePanel = this.togglePanel.bind(this);
    }
    init() {
        this.btn.addEventListener('click', this.boundTogglePanel);
    }
    togglePanel() {
        // toggle the visibility of the panel
        this.target.classList.toggle('visible');
        this.btn.classList.toggle('open-tab');
        // set the aria-expanded attribute to the opposite of its current value
        this.btn.setAttribute('aria-expanded', `${(this.btn.getAttribute('aria-expanded') !== 'true').toString()}`);
        // scroll to the panel if it is open by obtaining the target ID from the button's aria-controls attribute
        navUtils.scrollTo(`#${this.targetId}`);
    }
}

// Check for Own New Rate components when the document has loaded and initialise if we have any 
document.addEventListener('DOMContentLoaded', function () {
    const ownNewRateComponents = document.querySelectorAll('.own-new-rate-content-component');
    if (ownNewRateComponents) {
        ownNewRateComponents.forEach(function(component) {
            let ownNewRateComponent = new OwnNewRateComponent(component);
            ownNewRateComponent.init();
        });
    }
});
